import React from 'react';
import ResidencesList from '../../components/Views/ResidencesPage';
import { getSeoData } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';

const Residences = () => <ResidencesList />;

Residences.getInitialProps = async ({ apolloClient, asPath, req }) => {
  const seoData = await getSeoData(apolloClient, asPath, req);

  return {
    seoData
  };
};

Residences.getLayout = page => (
  <Layout isBottomNavigation={false} isShowBackButton isShowCloseButton={false}>
    {page}
  </Layout>
);

export default Residences;
